import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/lib/cart";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const cart = useCart();
  const [state, setState] = useState({ s: "checking" });

  useEffect(() => {
    let n = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          cart.clear();
          return setState({ s: "paid", number: data.order_number });
        }
        if (["expired", "failed"].includes(data.payment_status)) return setState({ s: "failed" });
      } catch { /* retry */ }
      if (++n < 10 && !stop) setTimeout(poll, 2000);
      else setState({ s: "pending" });
    };
    if (sid) poll();
    return () => { stop = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center space-y-5" data-testid="payment-result">
      {state.s === "checking" && <><Loader2 className="w-12 h-12 mx-auto animate-spin text-brand-navy" /><h1 className="text-4xl font-extrabold uppercase">Verifica pagamento…</h1></>}
      {state.s === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 mx-auto text-green-600" />
          <h1 className="text-5xl font-extrabold uppercase" data-testid="payment-success-title">Ordine confermato!</h1>
          <p className="text-slate-600">Ordine <span className="font-mono font-semibold" data-testid="payment-order-number">{state.number}</span>. Ti abbiamo inviato una email di conferma.</p>
        </>
      )}
      {state.s === "pending" && <><h1 className="text-4xl font-extrabold uppercase">Pagamento in elaborazione</h1><p className="text-slate-600">Riceverai una email appena confermato.</p></>}
      {state.s === "failed" && <><XCircle className="w-14 h-14 mx-auto text-brand-navy" /><h1 className="text-4xl font-extrabold uppercase">Pagamento non riuscito</h1></>}
      <Link to="/account" className="press inline-flex h-11 px-6 items-center rounded-md bg-brand-navy text-white font-semibold" data-testid="payment-go-orders-btn">I miei ordini</Link>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center space-y-5" data-testid="payment-cancel">
      <h1 className="text-5xl font-extrabold uppercase">Pagamento annullato</h1>
      <p className="text-slate-600">Il tuo carrello è ancora qui: puoi riprovare quando vuoi.</p>
      <Link to="/carrello" className="press inline-flex h-11 px-6 items-center rounded-md bg-brand-yellow text-brand-navy font-semibold">Torna al carrello</Link>
    </div>
  );
}
